import React from "react";

import PageComponent from "components/Page";
import TabsSwitch from "components/TabsSwitch";

import HeaderClient from "pages/client/components/headerClient";
import General from "pages/client/components/general";
import Visits from "pages/client/components/Visits";
import Anketa from "pages/client/components/anketa";
import Documents from "pages/client/components/documents";
import Invoice from "pages/client/components/Invoice";
import PhotoProtokol from "pages/client/components/photoProtokol";
import Analysis from "pages/client/components/analysis";
import Treatment from "pages/client/components/treatment";
import Notes from "pages/client/components/notes";
import TreatmentPlan from "pages/client/components/treatmentPlan";
import SelectDoctorDialog from "pages/client/components/SelectDoctorDialog";
import AddFamilyDialog from "pages/client/components/AddFamilyDialog";
import AddTratPlanDialog from "pages/client/components/AddTratPlanDialog";
import RefuseTratPlanDialog from "pages/client/components/RefuseTratPlanDialog";
import CopyTratPlanDialog from "pages/client/components/CopyTratPlanDialog";
import DeleteFamilyDialog from "pages/client/components/DeleteFamilyDialog";
import ChangeNoteDialog from "pages/client/components/ChangeNoteDialog";
import CancelInvoiceDialog from "pages/client/components/CancelInvoiceDialog";
import ConfirmGigienDialog from "pages/client/components/ConfirmGigienDialog";
import InviteDialog from "pages/client/components/InviteDialog";
import InvoiceDetailDialog from "pages/client/components/InvoiceDetailDialog";
import BillPaymentDialog from "pages/client/components/BillPaymentDialog";
import BalancePaymentDialog from "pages/client/components/BalancePaymentDialog";
import ReturnPaymentDialog from "pages/client/components/ReturnPaymentDialog";
import TransferPaymentDialog from "pages/client/components/TransferPaymentDialog";
import TreatmentPlanDetailDialog from "pages/client/components/TreatmentPlanDetailDialog";
import PinVisitsDialog from "pages/client/components/PinVisitsDialog";
import StatusDialog from "pages/client/components/StatusDialog";
import TeethDialog from "components/DentalFormula/TeethDialog";
import DoseDialog from "pages/client/components/DoseDialog";
import FileUploadDialog from "components/FileUploadDialog";
import AvatarUploadDialog from "components/AvatarUploadDialog";
import EditInfoPopup from "pages/client/components/editInfoPopup";
import AnketaPopup from "pages/client/components/AnketaPopup";
import InspectionPopup from "pages/client/components/inspectionPopup";
import PlanStageAddEditPopup from "pages/client/components/planStageAddEditPopup";
import AddEditInvoicePopup from "pages/client/components/AddEditInvoicePopup";

import './index.less';
import './themes/default.less';

export default class Client extends PageComponent {
    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            info: false,
            doctors: [],
            visitOpened: false,
        };

        this.pages = {};
        this.setPageTitle();
    }

    get dialogsMap() {
        return {
            "selectDoctor": SelectDoctorDialog,
            "addFamily": AddFamilyDialog,
            "addTratPlan": AddTratPlanDialog,
            "refuseTratPlan": RefuseTratPlanDialog,
            "copyTratPlan": CopyTratPlanDialog,
            "deleteFamily": DeleteFamilyDialog,
            "invite": InviteDialog,
            "changeNote": ChangeNoteDialog,
            "cancelInvoice": CancelInvoiceDialog,
            "confirmGigien": ConfirmGigienDialog,
            "teeth": TeethDialog,
            "fileUpload": FileUploadDialog,
            "avatarUpload": AvatarUploadDialog,
            "invoiceDetailDialog": InvoiceDetailDialog,
            "dose": DoseDialog,
            "billPayment": BillPaymentDialog,
            "balancePayment": BalancePaymentDialog,
            "returnPayment": ReturnPaymentDialog,
            "transferPayment": TransferPaymentDialog,
            "treatmentPlanDetail": TreatmentPlanDetailDialog,
            "pinVisits": PinVisitsDialog,
            "status": StatusDialog,
        };
    }

    get rightPopupsMap() {
        return {
            "editInfo": EditInfoPopup,
            "anketa": AnketaPopup,
            "inspection": InspectionPopup,
            "planStageAddEdit": PlanStageAddEditPopup,
            "addEditInvoicePopup": AddEditInvoicePopup,
        };
    }

    componentDidLoad() {
        const { tab } = this.state.urlProps;
        const cb = !tab ? null : this.changeTab.bind(this, tab);

        this.refresh(cb);
    }

    async refresh(cb) {
        this._helper.showLoading();
        const { clinicId } = this.state;
        const { id } = this.state.urlProps;
        const { data } = await this._request.clientsDetails.getData(id);
        const paymentWay = await this._request.paymentWay.getAll();

        if (data) {

            data.balance = (paymentWay.data || []).reduce((acc, it) => {
                if (it.paymentWaysHasBranchesList.some(clinic => clinic.domainId === this.state.clinicId))
                    acc[it.id] = { sum: 0, title: it.name, id: it.id };
                return acc;
            }, { total: { sum: 0, title: "Итого", id: 0 } });

            const repeatedVisits = await this._request.repeatedVisits.getRepeatedVisits(id);
            data.repeatedVisits = (repeatedVisits?.data || []).filter(it => it.visitRule.status === "NEW");

            (data.clientBalance?.clinicBalanceList || []).forEach(clinic => {
                Object.keys(data.balance).forEach(it => {
                    if (clinic.balanceByPaymentWays[it]) {
                        data.balance[it].sum += clinic.balanceByPaymentWays[it];
                        data.balance.total.sum += clinic.balanceByPaymentWays[it];
                    }

                });
            });

            data.mistyClient = false;
            if (![287, 1589].includes(clinicId)) { // у Газарова отключаем проверку на Мисти.
                const respMisty = await this._request.bonusMisty.getBalanceForClient(id);
                if (data.balance[53] && respMisty.message !== "MISTY_CLIENT_NOT_FOUND") {
                    data.mistyClient = true;
                    data.clientBalance.bonusesMisty = 0;
                    data.clientBalance.availableBonusesMisty = 0;
                    data.balance[53].sum = 0;

                    if (respMisty?.data?.availableBonuses || respMisty?.data?.availableActiveBonuses) {
                        data.balance[53].sum = respMisty.data.availableActiveBonuses;
                        data.clientBalance.bonusesMisty = respMisty.data.availableActiveBonuses;
                        data.clientBalance.availableBonusesMisty = respMisty.data.availableBonuses;
                    }
                }
            }

            const resp = await this._request.anketaQuestionnaireStat.getClientAnketa(id);
            const contactNameAnswer = (resp?.data || []).find(it => it.anketaQuestionAnswer.questionId === 92);
            const allergy = (resp?.data || []).find(it => ([64, 96]).includes(it.anketaQuestionAnswer.questionId));
            const hypertension = (resp?.data || []).find(it => ([40]).includes(it.anketaQuestionAnswer.questionId));
            data.isHypertension = false;
            if (hypertension?.anketaQuestionAnswer?.answerId === 1)
                data.isHypertension = true;

            if (contactNameAnswer?.value)
                data.contactName = contactNameAnswer.value;

            if (allergy?.value)
                data.allergy = allergy.value;

            this.setPageTitle(this._helper.string.formatFullName(data));
            this.changeState("info", data, cb?.apply ? cb : null);
        }

        this._helper.hideLoading();

        this.refreshTab();
    }

    refreshTab() {
        const currPage = this.pages[this.tabsView?.tabKey];

        if (currPage?.refresh?.apply)
            currPage.refresh();
    }

    onClinicChanged() {
        this.forceUpdate();
    }

    async updateClient(info) {
        this._helper.showLoading();

        const resp = await this._request.clientsDetails.update(this.state.info?.id, info);

        this._helper.hideLoading();

        if (resp?.data)
            this.refresh();
    }

    async deleteClient() {
        this._helper.showLoading();

        await this._request.clients.delete(this.state.info?.id);

        this._helper.hideLoading();

        this._helper.openPage("appointment");
        window.close();
    }

    async updateVisit(id, info, cb) {
        this._helper.showLoading();

        if (id && info)
            await this._request.visits.update(id, info);

        if (cb?.apply)
            cb();
    }

    async deleteRepeatedVisit(id) {
        this._helper.showLoading();
        await this._request.repeatedVisits.delete(id);
        this._helper.hideLoading();
        this.refresh();
    }

    async addUpdateRepeatedVisit(info) {
        this._helper.showLoading();
        await this._request.repeatedVisits.addUpdate(info);
        this._helper.hideLoading();
        this.refresh();
    }

    getAddEditProps(data, needAcc = false) {
        const { id, domainId, securedClientAccount } = this.state.info;
        const createdBy = this._helper.getProfileId();
        const createdTime = this._helper.date.toStr();

        const obj = {
            changedBy: createdBy,
            changedTime: createdTime,
        };

        if (needAcc)
            obj.accountId = securedClientAccount?.id || null;

        if (data?.id)
            return { ...obj, ...data };

        return {
            ...obj,
            clientId: id,
            domainId,
            createdBy,
            createdTime,
            ...data
        };
    }

    onToogleReturnVisit() {
        this.toggleState("visitOpened");
    }

    renderHeaderClient(info) {
        const { visitOpened } = this.state;
        const doctor = this.getDoctorById(info.doctorId);
        const coordinator = this.getDoctorById(info.coordinatorId);
        const doctorHygienist = this.getDoctorById(info.doctorHygienistId);

        return (
            <HeaderClient
                info={{ ...info, doctor, doctorHygienist, coordinator }}
                visitOpened={visitOpened}
                onToogleReturnVisit={this.onToogleReturnVisit.bind(this)}
                openDialog={this.openDialog.bind(this)}
                updateClient={this.updateClient.bind(this)}
                deleteClient={this.deleteClient.bind(this)}
            />
        );
    }

    changeTab(tab, props) {
        this.changeTabProps = props;

        this.tabsView.setTab(tab);
    }

    onTabsChange(tab) {
        if (this._helper.getPageTab() === tab)
            return;

        const props = this.changeTabProps || {};
        this.setPageTab(tab, props);

        delete this.changeTabProps;
    }

    setPageTab(tab, props) {
        const { id } = this.state.urlProps;
        const p = props || {};

        this._helper.setPageTab(tab || this.tabsView.tabKey, { id, ...p });
    }

    renderTabsClient(info) {
        const props = {
            opened: this.state.visitOpened,
            clinicId: this.state.clinicId,
            insurance: this.state.insurance,
            info,
            getDoctorById: this.getDoctorById.bind(this),
            getKnowAboutTitleById: this.getKnowAboutTitleById.bind(this),
            openRightPopup: this.openRightPopup.bind(this),
            openDialog: this.openDialog.bind(this),
            updateClient: this.updateClient.bind(this),
            deleteClient: this.deleteClient.bind(this),
            updateVisit: this.updateVisit.bind(this),
            getAddEditProps: this.getAddEditProps.bind(this),
            changeTab: this.changeTab.bind(this),
            refresh: this.refresh.bind(this),
            deleteRepeatedVisit: this.deleteRepeatedVisit.bind(this),
            addUpdateRepeatedVisit: this.addUpdateRepeatedVisit.bind(this),
            setPageTab: this.setPageTab.bind(this),
        };

        this.pages = {};

        return (
            <TabsSwitch
                ref={el => this.tabsView = el}
                className="flex1 minH0"
                links={["general", "notes", "visits", "questionnaire", "documents", "invoices", "photoProtocol", "analysis", "treatment", "treatmentPlan"]}
                tabs={["client.general", "client.note", "client.visits", "client.ank", "client.doc", "client.accounts", "client.photoProt", "client.analysis", "client.treat", "client.treatPlan"]}
                pages={[
                    <General ref={el => this.pages["general"] = el} name="general" {...props} />,
                    <Notes ref={el => this.pages["notes"] = el} name="notes flex col gap16" {...props} />,
                    <Visits ref={el => this.pages["visits"] = el} name="flex col gap16" {...props} />,
                    <Anketa ref={el => this.pages["questionnaire"] = el} name="anketa" {...props} />,
                    <Documents ref={el => this.pages["documents"] = el} name="documents" {...props} />,
                    <Invoice ref={el => this.pages["invoices"] = el} name="invoice flex col gap16" {...props} />,
                    <PhotoProtokol ref={el => this.pages["photoProtocol"] = el} name="photoProtokol" {...props} />,
                    <Analysis ref={el => this.pages["photoProtocol"] = el} name="analysis" {...props} />,
                    <Treatment ref={el => this.pages["treatment"] = el} name="treatment" {...props} />,
                    <TreatmentPlan ref={el => this.pages["treatmentPlan"] = el} name="treatmentPlan flex col gap16" {...props} />,
                ]}
                onBeforeChange={this.onTabsChange.bind(this)}
            />
        );
    }

    renderPage() {
        const { info } = this.state;

        if (!info)
            return <></>;

        return (
            <div className="flex1 flex col container gap32">
                {this.renderHeaderClient(info)}
                {this.renderTabsClient(info)}
            </div>
        );
    }
}


